import { v4 as uuidv4 } from 'uuid'
import { getRootDomain } from 'common/utils.js'

export default function ({ req, store }) {
  // Only execute on server side and in gray environment
  if (process.client) return
  console.log('middleware ---> get  grayFlag ---', process.env.grayType)
  if ((process.env.grayType || '').toLowerCase() !== 'gray') {
    console.log('middleware ---> not gray')
    try {
      store && store.commit && store.commit('SET_GREY_FLAG', '')
    } catch (e) {
      // Do nothing on error
    }
    const ctx = req && req.ctx
    if (ctx && ctx.cookies) {
      const { host } = req.headers || {}
      let domain = (host || '').replace(/\:\S+$/, '')
      domain = getRootDomain(domain)
      // Remove greyFlag cookie
      ctx.cookies.set('greyFlag', '', { domain, maxAge: 0 })
    }
    return
  }

  const ctx = req && req.ctx
  if (!ctx || !ctx.cookies) return

  let greyFlag = ctx.cookies.get('greyFlag') || ''

  // If greyFlag is already set, return
  if (greyFlag) {
    return
  }
  greyFlag = uuidv4()
  // Write greyFlag into the store for client usage
  try {
    store && store.commit && store.commit('SET_GREY_FLAG', greyFlag)
  } catch (e) {
    // Do nothing on error
  }

  const { host } = req.headers
  let domain = (host || '').replace(/\:\S+$/, '')
  domain = getRootDomain(domain)

  // Valid for 1 month
  const oneMonthMs = 30 * 24 * 60 * 60 * 1000
  ctx.cookies.set('greyFlag', greyFlag, { domain, maxAge: oneMonthMs })
}
